<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__brand">
        <img src="/logo.png" alt="logo" class="site-footer__logo" />
        <p class="site-footer__slogan">传递爱心 · 温暖社会</p>
      </div>
      <div class="site-footer__links">
        <h4>快速导航</h4>
        <nav class="footer-nav">
          <RouterLink v-for="item in navItems" :key="item.path" :to="item.path">{{ item.label }}</RouterLink>
        </nav>
      </div>
      <div class="site-footer__contact">
        <h4>联系我们</h4>
        <ul>
          <li><span>地址</span>江苏省苏州市苏州工业园区至和西路16号</li>
          <li><span>电话</span>13912786267</li>
        </ul>
      </div>
      <div class="site-footer__qrcode">
        <img src="/qrcode.jpg" alt="微信公众号二维码" />
        <p>扫码关注</p>
      </div>
    </div>
    <div class="site-footer__copyright">
      <p>版权所有 © 苏州市爱心达人公益慈善基金会</p>
    </div>
  </footer>
</template>

<script>
const NAV_ITEMS = [
  { label: '首页', path: '/' },
  { label: '公益项目', path: '/charityProject' },
  { label: '机构动态', path: '/organDynamic' },
  { label: '行业资讯', path: '/industryInformation' },
  { label: '信息披露', path: '/informationShow' },
  { label: '关于我们', path: '/aboutUs' }
]

export default {
  name: 'SiteFooter',
  data() {
    return { navItems: NAV_ITEMS }
  }
}
</script>

<style scoped>
.site-footer {
  background: #2c2c2c;
  color: rgba(255, 255, 255, 0.75);
  margin-top: auto;
}

.site-footer__inner {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 48px 20px 32px;
  display: grid;
  grid-template-columns: 1.2fr 1fr 1.2fr auto;
  gap: 32px;
  align-items: start;
}

.site-footer__logo {
  height: 48px;
  width: auto;
  filter: brightness(0) invert(1);
  opacity: 0.9;
  margin-bottom: 12px;
}

.site-footer__slogan {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  letter-spacing: 2px;
}

.site-footer h4 {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 16px;
}

.footer-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-nav a {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  transition: color var(--transition);
}

.footer-nav a:hover {
  color: var(--color-accent);
}

.site-footer__contact ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.site-footer__contact li {
  font-size: 13px;
  line-height: 1.8;
  margin-bottom: 8px;
}

.site-footer__contact span {
  color: rgba(255, 255, 255, 0.45);
  margin-right: 8px;
}

.site-footer__qrcode {
  text-align: center;
}

.site-footer__qrcode img {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  margin: 0 auto 8px;
}

.site-footer__qrcode p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.site-footer__copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  padding: 16px 20px;
}

.site-footer__copyright p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

@media (max-width: 900px) {
  .site-footer__inner {
    grid-template-columns: 1fr 1fr;
  }

  .site-footer__brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 560px) {
  .site-footer__inner {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
</style>
